import { ObraApp } from "../../models/obraApp.model";

export const dataDefault: ObraApp = {
    _: null,
    _2020: null,
    _2021: null,
    _2022: null,
    _2023: null,
    _2024: null,
    _2025: null,
    actaSuspencionFirmada: null,
    actaSuspencionMesFirma: null,
    anoFinalizaciónContrato: null,
    apareceEnBaseDeDatos: null,
    avanceDePlazoPlazoIntermedio: null,
    cantidadManoObra: null,
    cantidadObreroCesados: null,
    clasificacionDeSobrecostos: null,
    clasificacionPorKm: null,
    clasificacionPorMontos: null,
    clasificacionPorPlazo: null,
    clasificacionPorSobreplazo: null,
    contratista1: null,
    contratista2: null,
    contratistaConsorciosObra: null,
    desapareceDeBaseDeDatos: null,
    empresaSupervisora: null,
    estadoDeAvanceGeneral: null,
    estadoEjecucion: null,
    estadoEjecucionItem: null,
    externalIdcaptudata: null,
    externalIdCaptudata1: null,
    f103: null,
    fecha: new Date(),
    fechaActualizacion: null,
    fechaDeOrdenDeInicioEnMesAño: null,
    fechaFinalizacionEstimada: null,
    fechaFinalizacionVigente: null,
    fechaInicio: null,
    fechaRecibioInformación: null,
    ficmetodologicoContratosActivos: null,
    ficmetodologicoContratosActivosSinCeros: null,
    flexibilizacionClausulasContractuales: null,
    fpcmetodologicoContratosActivos: null,
    fpcmetodologicoContratosActivosSinCeros: null,
    gcrecord: null,
    index: null,
    jefeEquipo: 0,
    jefeEquipoItem: null,
    latitud: null,
    limitacionActividadesAdministrativas: null,
    localizacion: null,
    locked: null,
    longitud: null,
    longitudKm: null,
    manoObraPorMontoDeInversionMillones: null,
    mesDelÚltimoPagoAlContratistaEnMesAño: null,
    mesUltPagoContratista: null,
    moneda: 0,
    monedaItem: null,
    montoContractualDolares: null,
    montoContractualDolaresEnMillones: null,
    montoContractualInicialEnDólaresConTasaDeCambioPorMes: null,
    montoContractualVigenteModificadoDolares: null,
    montoContractualVigenteModificadoDólaresConTasaDeCam: null,
    montoContractualVigenteModificadoDolaresEnMillones: null,
    montoInicial: null,
    montoVigente: null,
    muestraDeChequeo: null,
    nacionalidadContratista: null,
    nacionalidadEmpresaSupervisora: null,
    nombre: null,
    nota: null,
    notaFinalEstadoGeneral: null,
    notaFinalSobrecostos: null,
    notaFinalSobreplazo: null,
    nuevoCronograma: null,
    oid: 0,
    optimisticLockField: null,
    orden: null,
    pagado: 0,
    pagoStockMateriales: null,
    pais: 0,
    paisItem: null,
    pendientePorVerificar: null,
    plazoContractualVigente: null,
    plazoContractualVigentePasoIntermedio: null,
    plazoInicialMeses: null,
    plazoInicialPorKm: null,
    plazoVigentePorKm: null,
    ponderadorFicMca: null,
    ponderadorFicMcasinCeros: null,
    ponderadorPfc: null,
    ponderadorPfcMcasinCeros: null,
    porcentajeAvanceAcumulado: null,
    porcentajeAvanceDePlazo: null,
    porcentajeBid: null,
    porcentajeContrapartida: null,
    precioInicialPorKmMillones: null,
    precioVigentePorKmMillones: null,
    problemaCadenaSuministros: null,
    programa: 0,
    programItem: null,
    provincia: null,
    rowClass: null,
    seSuscribioAdenda: null,
    sobreCostoEstimado: null,
    sobreCostoEstimadoNoMaterializado: null,
    sobrecostosMaterializados: null,
    sobrecostosUsd: null,
    sobrecostosUsdenMillones: null,
    sobreplazoMesesCalculado: null,
    subRegion: null,
    supervisora1: null,
    tipoCambio: 0,
    tipoCambioPorMesYmoneda: null,
    tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras: null,
    tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista: null,
    tipoObra: 0,
    tipoObraItem: null,
    totalPagoHastaLaFechaDolares: null,
    tramo: null,

    //calculated
    fechaOrdenInicioEnMesAño: null,
    ficConTazasCambioDiferenciadas: null,
    mesUltimoPagoContratistaMesAño: null,
    montoContractualInicialDolaresTasaCambio: null,
    montoContractualInicialDolaresTasaCambioMesYMoneda: null,
    montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda: null,
    tipoCambioMesYMonedaSegúnFechaInicioObras: null,
}